const zoneTypes = [
    { name: 'Auditorium', label: `Awditoriwm` },
    { name: 'Backstage', label: `Cefn llwyfan` },
    { name: 'FoodAndDrink', label: `Bwyd a diod` },
    { name: 'Gallery', label: `Oriel` },
    { name: 'MultiUse', label: `Amlddefnydd` },
    { name: 'Outdoor', label: `Awyr agored` },
    { name: 'Retail', label: `Manwerthu` },
    { name: 'Other', label: `Arall` },
];
const processZoneData = (_zoneData) => {
    let zoneData, draftZoneData, provisionData;
    if (!_zoneData) {
        return false;
    }
    zoneData = [
        { name: 'photo1', type: 'file', title: `un`, value: _zoneData.photo1 },
        { name: 'photo2', type: 'file', title: `un`, value: _zoneData.photo2 },
        { name: 'photo3', type: 'file', title: `un`, value: _zoneData.photo3 },
        { name: 'name', type: 'text', title: `Enw`, value: _zoneData.name, 'required': true },
        { name: 'description', type: 'textarea', title: `Disgrifiad`, value: _zoneData.description, 'required': true },
        { name: 'zoneType', type: 'select', title: `Math`, value: _zoneData.zoneType, 'required': true, options: zoneTypes },
        { name: 'videoUrl', type: 'url', title: `URL y daith ymgyfarwyddo`, value: _zoneData.videoUrl },
        { name: 'videoDescription', type: 'text', title: `Disgrifiad o\u2019r daith ymgyfarwyddo`, value: _zoneData.videoDescription, requiredIf: 'videoUrl' },
        { name: 'visualStory', type: 'url', title: `URL Stori Weledol`, value: _zoneData.visualStory },
    ];
    provisionData = {};
    if (_zoneData.hasOwnProperty('draftInfo') && _zoneData.draftInfo && _zoneData.approvalStatus == 'AwaitingResponse') {
        if (typeof _zoneData.draftInfo === 'string') {
            _zoneData.draftInfo = JSON.parse(_zoneData.draftInfo);
        }
        let photo1 = {};
        if (_zoneData.draftInfo.photo1PublicUrl) {
            photo1 = { publicUrl: _zoneData.draftInfo.photo1PublicUrl };
        }
        else if (_zoneData.photo1 && _zoneData.photo1.id) {
            photo1 = _zoneData.photo1;
        }
        if (_zoneData.draftInfo.photo1AltText) {
            photo1.altText = _zoneData.draftInfo.photo1AltText;
        }
        let photo2 = {};
        if (_zoneData.draftInfo.photo2PublicUrl) {
            photo2 = { publicUrl: _zoneData.draftInfo.photo2PublicUrl };
        }
        else if (_zoneData.photo2 && _zoneData.photo2.id) {
            photo2 = _zoneData.photo2;
        }
        if (_zoneData.draftInfo.photo2AltText) {
            photo2.altText = _zoneData.draftInfo.photo2AltText;
        }
        let photo3 = {};
        if (_zoneData.draftInfo.photo3PublicUrl) {
            photo3 = { publicUrl: _zoneData.draftInfo.photo3PublicUrl };
        }
        else if (_zoneData.photo3 && _zoneData.photo3.id) {
            photo3 = _zoneData.photo3;
        }
        if (_zoneData.draftInfo.photo3AltText) {
            photo3.altText = _zoneData.draftInfo.photo3AltText;
        }
        draftZoneData = [
            { name: 'photo1', type: 'file', title: `Lleoliad`, value: photo1 },
            { name: 'photo2', type: 'file', title: `Lleoliad`, value: photo2 },
            { name: 'photo3', type: 'file', title: `Lleoliad`, value: photo3 },
            { name: 'name', type: 'text', title: `Enw`, value: _zoneData.draftInfo.name, 'required': true },
            { name: 'description', type: 'textarea', title: `Disgrifiad`, value: _zoneData.draftInfo.description, 'required': true },
            { name: 'zoneType', type: 'select', title: `Pa fath o barth yw hwn?`, value: _zoneData.draftInfo.zoneType, 'required': true, options: zoneTypes },
            { name: 'videoUrl', type: 'url', title: `URL y daith ymgyfarwyddo`, value: _zoneData.draftInfo.videoUrl },
            { name: 'videoDescription', type: 'text', title: `Disgrifiad o\u2019r daith ymgyfarwyddo`, value: _zoneData.draftInfo.videoDescription, requiredIf: 'videoUrl' },
            { name: 'visualStory', type: 'url', title: `URL Stori Weledol`, value: _zoneData.draftInfo.visualStory },
        ];
    }
    else {
        draftZoneData = [];
    }
    if (_zoneData.provisions) {
        provisionData = _zoneData.provisions.map((item) => {
            return {
                name: item.name,
                id: item.id,
                standardId: item.standardId,
                image: item.photo?.publicUrl,
                imageId: item.photo?.id,
                alt: item.photo?.altText,
                description: item.description,
                draft: item.draft,
            };
        });
    }
    return {
        zoneData: zoneData,
        draftZoneData: draftZoneData,
        provisionData: provisionData
    };
};
export { processZoneData, zoneTypes };
